import React from 'react';
import styles from './ExperienceYears.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton';

export const ExperienceYears = () => {
    return (
        <div className={styles.wrapper}>
            <div>
                <FormTitle
                    formTitleText="業界の経験年数は何年ですか？"
                    dataViewLabel="EF_経験年数_pv"
                    dataClickLabel="EF_経験年数_戻る"
                />
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step2/experience1.png"
                        imageAlt="1年未満画像"
                        text="1年未満"
                        formKey={'experienceYears'}
                        formValue={'less_than_one_year'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'1年未満'}
                        dataClickLabel="EF_経験年数_1年未満"
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step2/experience2.png"
                        imageAlt="1~5年画像"
                        text="1~5年"
                        formKey={'experienceYears'}
                        formValue={'one_to_five_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'1~5年'}
                        dataClickLabel="EF_経験年数_1-5年"
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step2/experience3.png"
                        imageAlt="5~10年画像"
                        text="5~10年"
                        formKey={'experienceYears'}
                        formValue={'five_to_ten_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'5~10年'}
                        dataClickLabel="EF_経験年数_5-10年"
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step2/experience4.png"
                        imageAlt="10年以上画像"
                        text="10年以上"
                        formKey={'experienceYears'}
                        formValue={'more_than_ten_years'}
                        displayFormKey={'experienceYears'}
                        displayFormValue={'10年以上'}
                        dataClickLabel="EF_経験年数_10年以上"
                    />
                </div>
            </div>
        </div>
    );
};
